import React,{useEffect,useRef} from 'react'
import PropTypes from 'prop-types'
import {change} from 'redux-form'

import {renderLabel} from './index'

let DateField = (props) => {
  const {input, className, placeholder, type, meta,initialValue,label} = props
  const { error , touched,dispatch,form } = meta
  const {name} = input
  useEffect(()=>{
    dispatch(change(form,name,initialValue))
  },[initialValue,dispatch,form,name])

  const isError = () => {
    return error && touched
  }
  const getErrorMessage = () =>{
    return error
  }

  const onKeyUpRef = useRef(null)
  const onkeyUpCallback = (e)=>{
      if(e.keyCode !== 8 && e.keyCode !== 46){
        const val = onKeyUpRef.current.value
        if(val.length===2 && val.indexOf("/")===-1){
          onKeyUpRef.current.value = val+'/'
        }
      }
  }

  if(type==="hidden"){
    return (<>
      <input {...input} type={type} className={`${className?' '+className:''}`} />
      {isError()?<div className={'of-textfield__error status-font-2-100'}>{getErrorMessage()}</div>:<></>}
    </>)
  }
  return(
    <div className={`of-textfield${isError?' of-textfield--error':''}`}>
      {renderLabel(label,input.value)}
      <input {...input} maxLength={5} onKeyUp={onkeyUpCallback} ref={onKeyUpRef} type={type?type:'text'} className={`${isError()?'status-border-2-100':'lines-border-1-100'} of-textfield__input${className?' '+className:''}`} placeholder={placeholder}/>
      {isError()?<div className={'of-textfield__error status-font-2-100'}>{getErrorMessage()}</div>:<></>}
    </div>
  )
}

DateField.propTypes = {
  input: PropTypes.any,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.any,
  initialValue: PropTypes.any,
  label: PropTypes.string
}

export default DateField